import React, { Component } from "react";
import NavMenu from "../../navmenu/NavMenu";
import AboutHeader from "./AboutHeader";
import AboutBios from "./AboutBios";
import Footer from "../../footer/Footer";
import "../../../styles/pages/about/About.css";
import onScrollHandler from "../../../utilities/onScrollHandler";
import NextPrompt from "../../nextprompt/NextPrompt";

export default class About extends Component {
  componentDidMount() {
    this.onScrollHandler = new onScrollHandler();
  }
  render() {
    return (
      <div className="About page-wrapper">
        <NavMenu />

        <div className="content-container gutters">
          <AboutHeader />
          <AboutBios />
        </div>

        <NextPrompt />
        <Footer page={"about"} />
      </div>
    );
  }
}
